var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplacementCostIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "29px",
    viewBox: "0 0 26 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 1.39940363 25.9055053 1.39940363 25.9055053 15.6315789 0 15.6315789"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latch-Insurance---Endorsement-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Replacement-Cost",
    transform: "translate(-47.000000, -251.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(47.000000, 251.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2681632,8.31230526 C25.3662158,8.24693684 25.4585842,8.16877895 25.5395842,8.07641053 C25.6504263,7.95562105 25.7342684,7.8192 25.7953737,7.67709474 C25.8706895,7.49662105 25.9062158,7.3062 25.9048437,7.11577895 C25.9076368,6.77330526 25.7868474,6.42941053 25.5395842,6.15372632 C25.4585842,6.06277895 25.3662158,5.98462105 25.2681632,5.91925263 L19.0993737,0.365778947 C18.5153211,-0.160010526 17.6172158,-0.113115789 17.0928474,0.469515789 C16.5670579,1.05356842 16.6139526,1.95167368 17.1965842,2.47746316 L20.7591632,5.68477895 L1.42147895,5.68477895 C0.637057895,5.68477895 0.000426315789,6.32141053 0.000426315789,7.10583158 C0.000426315789,7.89025263 0.637057895,8.52688421 1.42147895,8.52688421 L20.7819,8.52688421 L17.1965842,11.7540947 C16.6139526,12.2798842 16.5670579,13.1779895 17.0928474,13.7606211 C17.6172158,14.3446737 18.5153211,14.3915684 19.0993737,13.8672 L25.2681632,8.31230526 Z",
    id: "Fill-1",
    fill: "#FDFDFB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 12.810789)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-replacement-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.485715789,9.59608421 C0.443084211,9.55913684 0.403294737,9.51934737 0.364926316,9.47671579 C0.264031579,9.36445263 0.184452632,9.2394 0.124768421,9.10866316 C0.0409263158,8.91966316 -0.00170526316,8.71787368 -0.000333208026,8.51466316 C-0.00312631579,8.17361053 0.117663158,7.82971579 0.364926316,7.55403158 C0.447347368,7.46308421 0.539715789,7.38350526 0.636347368,7.31955789 L6.80655789,1.76466316 C7.08082105,1.5174 7.42471579,1.39661053 7.76718947,1.39940363 C8.15229474,1.40229474 8.53455789,1.56145263 8.81308421,1.86982105 C9.33745263,2.45387368 9.29055789,3.35197895 8.70792632,3.87776842 L5.12261053,7.10497895 L24.4844526,7.10497895 C25.2688737,7.10497895 25.9055053,7.74161053 25.9055053,8.52603158 C25.9055053,9.31187368 25.2688737,9.94708421 24.4844526,9.94708421 L5.14534737,9.94708421 L8.70792632,13.1544 C9.29055789,13.6801895 9.33745263,14.5782947 8.81308421,15.1609263 C8.46634737,15.5460316 7.95618947,15.6980842 7.48297895,15.6057158 C7.23855789,15.5574 7.00408421,15.4451368 6.80655789,15.2660842 L0.636347368,9.71118947 C0.585189474,9.67708421 0.534031579,9.63871579 0.485715789,9.59608421",
    id: "Fill-3",
    fill: "#FDFDFB",
    mask: "url(#mask-replacement-2)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplacementCostIcon);
export default __webpack_public_path__ + "static/media/replacement_cost_icon.69a23df2.svg";
export { ForwardRef as ReactComponent };